import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export const BottomNav: React.FC = () => {
  const auth = useContext(AuthContext);
  const user = auth?.user;

  return (
    <nav
      className="mobile-bottom-nav"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: 'var(--bottom-nav-height)',
        backgroundColor: 'var(--bg-secondary)',
        borderTop: '1px solid var(--border-subtle)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        zIndex: 50,
        padding: '0 var(--space-2)',
      }}
      aria-label="Mobile Navigation"
    >
      <NavLink
        to="/"
        end
        style={({ isActive }) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 'var(--min-touch-target)',
          minHeight: 'var(--min-touch-target)',
          color: isActive ? 'var(--accent-primary)' : 'var(--text-muted)',
          textDecoration: 'none',
          fontSize: 'var(--font-size-xs)',
          gap: '2px',
        })}
      >
        <span style={{ fontSize: '1.25rem' }}>🏠</span>
        <span>Home</span>
      </NavLink>

      <NavLink
        to="/library"
        style={({ isActive }) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 'var(--min-touch-target)',
          minHeight: 'var(--min-touch-target)',
          color: isActive ? 'var(--accent-primary)' : 'var(--text-muted)',
          textDecoration: 'none',
          fontSize: 'var(--font-size-xs)',
          gap: '2px',
        })}
      >
        <span style={{ fontSize: '1.25rem' }}>📚</span>
        <span>Catalog</span>
      </NavLink>

      <NavLink
        to="/my-learning"
        style={({ isActive }) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 'var(--min-touch-target)',
          minHeight: 'var(--min-touch-target)',
          color: isActive ? 'var(--accent-primary)' : 'var(--text-muted)',
          textDecoration: 'none',
          fontSize: 'var(--font-size-xs)',
          gap: '2px',
        })}
      >
        <span style={{ fontSize: '1.25rem' }}>📖</span>
        <span>Learning</span>
      </NavLink>

      <NavLink
        to="/progress"
        style={({ isActive }) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: 'var(--min-touch-target)',
          minHeight: 'var(--min-touch-target)',
          color: isActive ? 'var(--accent-primary)' : 'var(--text-muted)',
          textDecoration: 'none',
          fontSize: 'var(--font-size-xs)',
          gap: '2px',
        })}
      >
        <span style={{ fontSize: '1.25rem' }}>📊</span>
        <span>Progress</span>
      </NavLink>

      {user?.isEducator && (
        <NavLink
          to="/authoring"
          style={({ isActive }) => ({
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 'var(--min-touch-target)',
            minHeight: 'var(--min-touch-target)',
            color: isActive ? 'var(--accent-primary)' : 'var(--text-muted)',
            textDecoration: 'none',
            fontSize: 'var(--font-size-xs)',
            gap: '2px',
          })}
        >
          <span style={{ fontSize: '1.25rem' }}>✏️</span>
          <span>Studio</span>
        </NavLink>
      )}

      <style>{`
        @media (min-width: 768px) {
          .mobile-bottom-nav {
            display: none !important;
          }
        }
      `}</style>
    </nav>
  );
};
